<template>
  <el-dialog
    width="800px"
    append-to-body
    :visible.sync="popupOpen"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    center
    custom-class="orderButtonConfirmDialog odmikDialoga"
    :fullscreen="$screen.breakpoint === 'xs'"
    v-loading="loading"
  >
    <template v-slot:title>
      <div style="text-align: center;" class="mt-3 open-sans-20pt">
        Sprememba telefonske številke
      </div>
    </template>
    <div>
      <el-steps :active="activeGsmChangeTab" finish-status="success" simple>
        <el-step :title="$screen.breakpoint === 'xs' ? `1` : `Korak 1`"></el-step>
        <el-step :title="$screen.breakpoint === 'xs' ? `2` : `Korak 2`"></el-step>
        <el-step :title="$screen.breakpoint === 'xs' ? `3` : `Korak 3`"></el-step>
        <el-step :title="$screen.breakpoint === 'xs' ? `4` : `Zaključek`"></el-step>
      </el-steps>
      <div class="content" v-if="user !== null">
        <template v-if="activeGsmChangeTab === 0">
          <el-form
            label-width="230px"
            label-position="top"
            @submit.native.prevent="checkConfirmationOfOldNumber()"
          >
            <div>
              <p class="navadno-besedilo mt-3">{{selectedVerifyTypeTextTop}}</p>
              <el-input
                class="velikost-input pozicija-sms-geslo"
                placeholder="Potrditveni žeton"
                type="text"
                v-model="user.phoneNumberChange.oldPhoneConfirmationToken"
                :disabled="user.phoneNumberChange.oldPhoneConfirmationLoading"
                ref="telChangeStep1Input"
              />
              <div class="pozabljenoGeslo mt-3" v-loading="loadingTokenSend">
                <img src="/static/img/Domov/Icon-awesome-exclamation-triangle-black.png">
                <label>Niste prejeli žetona?</label>
                <a @click="sendConfirmationToOldNumber()" style="cursor: pointer">
                  Pošlji ponovno.
                </a> ali
                <a @click="selectedVerifyType = 'email'; sendConfirmationToOldNumber();" v-if="selectedVerifyType === 'sms'" style="cursor: pointer;">
                  pošlji žeton na e-poštni naslov
                </a>
                <a @click="selectedVerifyType = 'sms'; sendConfirmationToOldNumber();" v-if="selectedVerifyType === 'email'" style="cursor: pointer;">
                  pošlji žeton na sms
                </a>.
              </div>
              <div class="d-flex mt-5" style="justify-content: space-between">
                <a class="stil-gumb-preklici" @click="popupOpen = false" type="primary">
                  PREKLIČI
                </a>
                <el-button
                  type="primary"
                  @click="checkConfirmationOfOldNumber()"
                  class="gumb-potrdi"
                  style="width: auto !important;"
                  :disabled="loadingTokenSend || user.phoneNumberChange.oldPhoneConfirmationLoading"
                  v-loading="user.phoneNumberChange.oldPhoneConfirmationLoading"
                >
                  NASLEDNJI KORAK
                </el-button>
              </div>
            </div>
          </el-form>
        </template>
        <template v-if="activeGsmChangeTab === 1">
          <el-form
            label-width="200px"
            label-position="top"
          >
            <p class="navadno-besedilo mt-3">Prosimo vas, da vnesete svojo <b>novo telefonsko številko</b>.<br/>
              Po vnosu boste prejeli <b>SMS s potrditvenim žetonom</b>, s katerim bomo preverili vašo identiteto.</p>
              <div class="d-flex">
                <el-select
                  class="lista-zacetnih-st input-telefonska-stevilka mr-2"
                  v-model="user.phoneNumberChange.phoneNumberPrefix"
                  :placeholder="listaZacetnihSt[0]"
                  style="max-width: 100px;"
                  :disabled="loadingTokenSend"
                  ref="telChangeStep2Input"
                >
                  <el-option
                    v-for="st in listaZacetnihSt"
                    :value="st"
                    :label="st"
                    :key="st">
                  </el-option>
                </el-select>
                <el-input
                  placeholder="100100"
                  class="tel-st-vnosno-polje"
                  :maxlength="6"
                  show-word-limit
                  type="text"
                  v-model="user.phoneNumberChange.phoneNumber"
                  :disabled="loadingTokenSend"
                  @keyup.native.enter="sendConfirmationToNewNumber()"
                >
                </el-input>
              </div>
            <div class="d-flex mt-5" style="justify-content: space-between">
              <a class="stil-gumb-preklici" @click="popupOpen = false" type="primary">
                PREKLIČI
              </a>
              <el-button
                type="primary"
                @click="sendConfirmationToNewNumber()"
                class="gumb-potrdi"
                style="width: auto !important;"
                :disabled="loadingTokenSend"
                v-loading="loadingTokenSend"
              >
                NASLEDNJI KORAK
              </el-button>
            </div>
          </el-form>
        </template>
        <template v-if="activeGsmChangeTab === 2">
          <el-form
            label-width="230px"
            label-position="top"
            @submit.native.prevent="checkConfirmationForNewPhoneNumberChange()"
          >
            <div>
              <p class="navadno-besedilo mt-3">
                Na vašo novo telefonsko številko smo poslali SMS s potrditvenim žetonom. Prosimo, da ga vnesete v spodnje polje.
              </p>
              <el-input
                class="velikost-input pozicija-sms-geslo"
                placeholder="SMS žeton"
                type="text"
                v-model="user.phoneNumberChange.newPhoneConfirmationToken"
                :disabled="user.phoneNumberChange.newPhoneConfirmationLoading"
                ref="telChangeStep3Input"
              >
              </el-input>
              <span class="pozabljenoGeslo">
                  <img src="/static/img/Domov/Icon-awesome-exclamation-triangle-black.png">
                  <label>Niste prejeli žetona?</label>
                  <a @click="sendConfirmationToNewNumber()" style="cursor: pointer" v-loading="loadingTokenSend">
                    Pošlji ponovno.
                  </a>
                </span>
              <div class="d-flex mt-5" style="justify-content: space-between">
                <a class="stil-gumb-preklici" @click="popupOpen = false" type="primary">
                  PREKLIČI
                </a>
                <el-button
                  type="primary"
                  @click="checkConfirmationForNewPhoneNumberChange()"
                  class="gumb-potrdi"
                  style="width: auto !important;"
                  v-loading="user.phoneNumberChange.newPhoneConfirmationLoading"
                  :disabled="loadingTokenSend || user.phoneNumberChange.newPhoneConfirmationLoading"
                >
                  SPREMENI ŠTEVILKO
                </el-button>
              </div>
            </div>
          </el-form>
        </template>
        <template v-if="activeGsmChangeTab === 3">
          <p class="navadno-besedilo mt-3">Telefonska številka je bila uspešno spremenjena!</p>
          <div style="text-align: right;">
            <el-button
              type="primary"
              class="gumb-potrdi"
              style="width: auto !important;"
              @click="popupOpen = false"
            >
              ZAPRI
            </el-button>
          </div>
        </template>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import InfoKomponentaGlobalna from '../../../../UIComponents/InfoKomponentaGlobalna.vue'
import {Button, Dialog, Input, Option, Select, Step, Steps} from 'element-ui'
import {ZacetneStevilkeUmtsEnum} from '../../../../../assets/js/Enum/ZacetneStevilkeUmtsEnum'
import LoggedInUser from '../../../../../assets/js/Common/LoggedInUser'

export default {
  name: 'SpremembaTelefonskeStevilkePopup',
  components: {
    InfoKomponentaGlobalna,
    [Dialog.name]: Dialog,
    [Steps.name]: Steps,
    [Step.name]: Step,
    [Input.name]: Input,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button
  },
  emits: ['phoneNumberChanged', 'input'],
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      activeGsmChangeTab: 0,
      listaZacetnihSt: ZacetneStevilkeUmtsEnum,
      user: null,
      loading: false,
      loadingTokenSend: false,
      selectedVerifyType: 'sms'
    }
  },
  computed: {
    popupOpen: {
      get () {
        return this.value
      },
      set (input) {
        this.$emit('input', input)
      }
    },
    selectedVerifyTypeTextTop () {
      if (this.user === null) {
        return ''
      }
      return this.selectedVerifyType === 'sms'
        ? 'Na vašo telefonsko številko ' + this.user.phone + ' ste prejeli potrditveni SMS z žetonom, s katerim preverimo, da ste zahtevo za spremembo številke sprožili vi. Prosimo, vpišite ga spodaj.'
        : 'Na vaš elektronski naslov ' + this.user.email + ' ste prejeli potrditveni žeton, s katerim preverimo, da ste zahtevo za spremembo številke sprožili vi. Prosimo, vpišite ga spodaj.'
    }
  },
  methods: {
    async sendConfirmationToOldNumber () {
      try {
        this.loadingTokenSend = true
        this.user.phoneNumberChangeReset()
        await this.user.sendConfirmationNotificationForPhoneNumberChange(this.selectedVerifyType)
      } catch (e) {
        this.ShowErrorMessage({message: e.message, duration: 0})
      }
      this.loadingTokenSend = false
    },
    async checkConfirmationOfOldNumber () {
      try {
        await this.user.checkConfirmationForPhoneNumberChange()
        this.activeGsmChangeTab = 1
        setTimeout(() => {
          this.$refs.telChangeStep2Input.focus()
        }, 500)
      } catch (e) {
        this.ShowErrorMessage({message: e.message, duration: 0})
      }
    },
    async sendConfirmationToNewNumber () {
      try {
        if (this.loadingTokenSend === false) {
          this.loadingTokenSend = true
          await this.user.sendConfirmationForNewPhoneNumber()
          this.activeGsmChangeTab = 2
          setTimeout(() => {
            this.$refs.telChangeStep3Input.focus()
          }, 500)
        }
      } catch (e) {
        this.ShowErrorMessage({message: e.message, duration: 0})
      }
      this.loadingTokenSend = false
    },
    async checkConfirmationForNewPhoneNumberChange () {
      try {
        await this.user.checkConfirmationForNewPhoneNumberChange()
        this.activeGsmChangeTab = 3
        this.user.phone = this.user.phoneNumberChange.phoneNumberPrefix + this.user.phoneNumberChange.phoneNumber
        this.$emit('phoneNumberChanged', this.user.phoneNumberChange.phoneNumberPrefix, this.user.phoneNumberChange.phoneNumber)
      } catch (e) {
        this.ShowErrorMessage({message: e.message, duration: 0})
      }
    }
  },
  watch: {
    async value (val) {
      if (val === true) {
        if (this.user === null) {
          try {
            this.loading = true
            this.user = new LoggedInUser()
            await this.user.loadLoggedInUserDetails()
            if (this.user.phone === null || this.user.phone === '' || String(this.user.phone).length < 4) {
              this.selectedVerifyType = 'email'
            } else {
              this.selectedVerifyType = 'sms'
            }
            setTimeout(() => {
              this.$refs.telChangeStep1Input.focus()
            }, 500)
          } catch (e) {
            this.ShowErrorMessage({message: e.message, duration: 0})
          }
        }
        this.activeGsmChangeTab = 0
        await this.sendConfirmationToOldNumber()
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Mojprofil/UrejanjeProfila/SpremembaTelefonskeStevilkePopup.vue